// @flow
import React from "react"
import { connect } from "react-redux"
import { Motion, spring, presets } from "react-motion"
import { Helmet } from "react-helmet"
import {
  Modal,
  Content,
  Body,
  Header,
  Footer,
  PrimaryHeading,
  SubHeading,
  FooterLink
} from "../UI/Modal"
import Loader from "../UI/Loader"
import { replace } from "react-router-redux"
import { SubmissionError } from "redux-form"
import SignupForm from "./SignupForm"
import { createUser, loginUser } from "../Auth"

type SignUpValues = {
  name: string,
  email: string,
  password: string
}

type Props = { replace: string => void }
type State = { loading: boolean }

class Signup extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  async creatNewUser(values: SignUpValues) {
    const { replace } = this.props
    this.setState(() => ({ loading: true }))
    let json = null
    try {
      json = await createUser(values)
    } catch (error) {
      this.setState(() => ({ loading: false }))
      throw new SubmissionError({ _error: "Could not connect." })
    }
    if (json.errors && json.errors.length > 0) {
      this.setState(() => ({ loading: false }))
      throw new SubmissionError({
        _error: "Could not create your account.",
        ...json.errors.state
      })
    }
    try {
      await loginUser(values.email, values.password)
    } catch (error) {
      replace("/login")
    }
    replace("/admin")
  }

  render() {
    const { loading } = this.state

    return (
      <Modal>
        <Helmet>
          <title>Create Account</title>
        </Helmet>
        <Motion
          key="signupModal"
          defaultStyle={{ y: -100, a: 0 }}
          style={{
            y: spring(0, presets.wobbly),
            a: spring(1, presets.noWobble)
          }}
        >
          {is => (
            <Body
              style={{
                transform: `translate(0px, ${is.y}px)`,
                opacity: is.a
              }}
            >
              <Loader loading={loading}>
                <Header>
                  <PrimaryHeading>Kiosk Admin</PrimaryHeading>
                  <SubHeading>Create Account</SubHeading>
                </Header>
                <Content>
                  <SignupForm
                    onSubmit={(values: SignUpValues) =>
                      this.creatNewUser(values)}
                  />
                </Content>
                <Footer>
                  <FooterLink to="/auth/login">
                    Already have an account?
                  </FooterLink>
                </Footer>
              </Loader>
            </Body>
          )}
        </Motion>
      </Modal>
    )
  }
}

export default connect(null, { replace })(Signup)



// WEBPACK FOOTER //
// ./src/PublicArea/Signup.js